import { render, staticRenderFns } from "./VxNoInfoDash.vue?vue&type=template&id=023e4a95&"
import script from "./VxNoInfoDash.vue?vue&type=script&lang=js&"
export * from "./VxNoInfoDash.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports